export {default as hexbin} from "./src/hexbin";
